import { defineStore } from "pinia";
import axios from "axios";
import { useNotificationsStore } from "@/store/notifications";
import { t } from "@/controllerLK/AvalLocalization";

export const useSourceStore = defineStore({
  id: "ProjectSourceStore",
  state: () => ({
    sourceList: []
  }),
  getters: {},
  actions: {
    // В новом API источники не привязаны к проекту, поэтому projectId не используется в URL.
    // Сигнатуры сохранены для совместимости вызовов.
    async getProjectSource (projectId) {
      try {
        const result = await axios.get(process.env.VUE_APP_NEW_API + "sources/internal");
        this.sourceList = result.data.results;
        return this.sourceList;
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    async createProjectSource(projectId, source) {
      const notificationsStore = useNotificationsStore();
      try {
        await axios.post(process.env.VUE_APP_NEW_API + "sources/internal", source);
        notificationsStore.createNotify(t("source_page.toast.create", source.name), "success");
      } catch (e) {
        console.log(e);
      }
    },
    async updateProjectSource (projectId, source) {
      const notificationsStore = useNotificationsStore();
      try {
        await axios.put(process.env.VUE_APP_NEW_API + `sources/internal/${source.id}`, source);
        notificationsStore.createNotify(t("source_page.toast.update", source.name), "success");
      } catch (e) {
        console.log(e);
      }
    },
    async deleteProjectSource (projectId, source) {
      const notificationsStore = useNotificationsStore();
      try {
        await axios.delete(process.env.VUE_APP_NEW_API + `sources/internal/${source.id}`);
      } catch (e) {
        console.log(e);
      } finally {
        notificationsStore.createNotify(t("source_page.toast.delete", source.name), "success");
      }
    }
  },
});

export const ISourceMock = {
  id: null,
  project_id: "",
  type: "rss",
  name: "",
  description: "",
  language: "",
  start_url: "https://",
  is_archived: false,
  is_enabled: false,
  cron: "0 * * * * ?",
  tag_ids: [],
  tags: [],
  settings: {
    username: null,
    password: null,
    user_agent: null,
    crawler: false,
    ignore_http_cache: false,
    fetch_via_proxy: false
  }
};

export const sourceTypeOptions = [
  {
    label: "RSS",
    value: "rss",
  },
  {
    label: "Page",
    value: "page",
  },
  {
    label: "Vkontakte",
    value: "vkontakte",
  },
  {
    label: "Instagram",
    value: "instagram",
  },
  {
    label: "Facebook",
    value: "facebook",
  },
  {
    label: "Telegram",
    value: "telegram",
  },
  {
    label: "Twitter",
    value: "twitter",
  },
  {
    label: "Dzen",
    value: "dzen",
  }
];

export const sourceLanguageOptions = [
  {
    label: t("source_page.language.ru"),
    value: "russian",
  },
  {
    label: t("source_page.language.en"),
    value: "english",
  },
  // Задача 2030 - оставить только русский и английский
  // {
  //   label: t('source_page.language.es'),
  //   value: "ES",
  // },
  // {
  //   label: t('source_page.language.fr'),
  //   value: "FR",
  // },
];